import React, { useState, useEffect } from 'react';
import { ui } from '../../../config/uiSizes';

interface RemovePrefixParametersProps {
  parameters?: Record<string, unknown>;
  onParametersChange?: (parameters: Record<string, unknown>) => void;
}

export const RemovePrefixParameters: React.FC<RemovePrefixParametersProps> = ({
  parameters,
  onParametersChange
}) => {
  const [prefix, setPrefix] = useState<string>((parameters?.['prefix'] as string) || '');
  const [applyToProperty, setApplyToProperty] = useState<string>(
    (parameters?.['applyToProperty'] as string) || 'name'
  );

  useEffect(() => {
    if (onParametersChange) {
      onParametersChange({
        prefix,
        applyToProperty
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [prefix, applyToProperty]);

  return (
    <div className={`border-2 border-gray-200 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-800 ${ui.page.cardPadding}`}>
      <div className={`${ui.mb.title}`}>
        <h3 className={`${ui.text.sectionTitle} font-bold text-gray-900 dark:text-gray-100`}>Remove Prefix</h3>
        <p className={`${ui.text.label} text-gray-600 dark:text-gray-400 mt-1`}>
          Remove a specified prefix from resource names.
        </p>
      </div>

      <div className="space-y-4">
        {/* Prefix Input */}
        <div>
          <label className={`block ${ui.text.label} font-medium text-gray-700 dark:text-gray-300 mb-2`}>
            Prefix to Remove <span className="text-red-500">*</span>
          </label>
          <input
            type="text"
            value={prefix}
            onChange={(e) => setPrefix(e.target.value)}
            placeholder="DEV_"
            className={`w-full ${ui.input.base} border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-700 text-gray-900 dark:text-gray-100 focus:outline-none focus:ring-2 focus:ring-blue-500`}
          />
          <p className={` ${ui.text.xs} text-gray-500 dark:text-gray-400 mt-1`}>
            Examples: "OLD_", "TEMP_", "DEV_"
          </p>
        </div>

        {/* Apply To Property */}
        <div>
          <label className={`block ${ui.text.label} font-medium text-gray-700 dark:text-gray-300 mb-2`}>
            Apply To Property
          </label>
          <input
            type="text"
            value={applyToProperty}
            onChange={(e) => setApplyToProperty(e.target.value)}
            placeholder="name"
            className={`w-full ${ui.input.base} border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-700 text-gray-900 dark:text-gray-100 focus:outline-none focus:ring-2 focus:ring-blue-500`}
          />
          <p className={` ${ui.text.xs} text-gray-500 dark:text-gray-400 mt-1`}>
            Property name to modify (usually "name")
          </p>
        </div>
      </div>
    </div>
  );
};

export default RemovePrefixParameters;
